import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import CancellationsList from '../../components/Panel/Cancellations/CancellationsList';
import {Link} from 'react-router';
import urlBase from '../../url-base';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    breadcrumb: {
      fontSize: 12,
      float: 'right'
    }
  };

const CancellationsPage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
          &nbsp;>&nbsp;
          <Link style={{color:'#505050'}} to={urlBase.client + "panel/cancellations"}>
            Cancelamentos
          </Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Lista de
          <span style={styles.tituloPagina}> Cancelamentos</span>
        </h3>

        <CancellationsList />

      </div>
    </Panel>

  );
};

export default CancellationsPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/CancellationsPage.js
 **/